<template>
  <div>
    <communication-filters :filter-type.sync="filterType" />

    <div style="width: 100%">
      <b-card>
        <b-card-title>Suodata</b-card-title>
        <b-row>
          <b-col cols="4" style="display: flex; flex-direction: row; justify-content: space-between;">
            <v-select
              id="state"
              v-model="state"
              style="width: 50%; text-transform: capitalize;"
              :placeholder="$t('state')"
              :options="STATE_OPTIONS"
            />
            <v-select
              id="city"
              v-model="city"
              style="width: 45%"
              :placeholder="$t('city')"
              taggable
              :no-drop="true"
            />
          </b-col>
        </b-row>
      </b-card>
    </div>

    <b-row>
      <create-new-item
        v-if="currentPage === 1"
        :filter-type="filterType"
        @click="handleShowForm()"
      />

      <b-col v-for="(item, index) in dataList" :key="index" md="6" lg="4">
        <sms-item v-if="isCurrentFilterSms && item.type === COMMUNICATION_TYPES.SMS" :item="item" @show-info="handleShowForm(item)" />
        <communication-item v-else :item="item" :is-deleting="isDeleting" @edit-communication="handleShowForm(item)" @delete-announcement="deleteAnnouncement(item.id)" />
      </b-col>
    </b-row>

    <b-row v-if="dataList.length > 0">
      <b-col cols="12" class="d-flex justify-content-end">
        <ul role="menubar" class="pagination b-pagination pagination-lg mr-5">
          <li
            role="presentation"
            :class="['page-item', currentPage > 1 ? '' : 'disabled']"
            @click="changePage(PREV)"
          >
            <button role="menuitem" type="button" class="page-link">
              <span class="text-primary"> Prev </span>
            </button>
          </li>
          <li role="presentation" class="page-item active">
            <button role="menuitemradio" type="button" class="page-link">
              {{ currentPage }}
            </button>
          </li>
          <li
            role="presentation"
            :class="['page-item', canLoadMore ? '' : 'disabled']"
            @click="changePage(NEXT)"
          >
            <button role="menuitem" type="button" class="page-link">
              <span class="text-primary"> Next </span>
            </button>
          </li>
        </ul>
      </b-col>
    </b-row>

    <sms-form
      v-if="filterType === COMMUNICATION_TYPES.SMS"
      v-model="modalFormShow"
      :sms="communicationItemEdit"
      @save="handleCreateUpdateSms"
    />

    <compose-message
      v-else
      v-model="modalFormShow"
      :message="communicationItemEdit"
      :modal-type="
        filterType === COMMUNICATION_TYPES.QUESTIONNAIRE
          ? COMMUNICATION_TYPES.QUESTIONNAIRE
          : COMMUNICATION_TYPES.ANNOUNCEMENT
      "
    />
  </div>
</template>

<script>
import { BRow, BCol, BCard, BCardTitle } from 'bootstrap-vue'
import vSelect from 'vue-select'
import { COMMUNICATION_TYPES } from '@/shared/constants/communications'
import { STATE_OPTIONS } from '@/shared/constants/options'
import { ref, computed, watch } from '@vue/composition-api'
import { createUpdateSms } from '@/shared/services/communicationService'
import ToastificationContent from '@hw-ui/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import { fetchItems } from '@/shared/services/collection'
// eslint-disable-next-line import/no-cycle
import router from '@/shared/router'
import CommunicationFilters from './CommunicationFilters.vue'
import CommunicationItem from './CommunicationItem.vue'
import SmsItem from './SmsItem.vue'
import CreateNewItem from './CreateNewItem.vue'
import ComposeMessage from './ComposeMessage.vue'
import SmsForm from './SmsForm.vue'

export default {
  components: {
    BRow,
    BCol,
    // BPagination,
    CommunicationFilters,
    CommunicationItem,
    SmsItem,
    CreateNewItem,
    ComposeMessage,
    SmsForm,
    vSelect,
    BCard,
    BCardTitle,
  },
  data() {
    return {
      city: null,
      state: null,
      STATE_OPTIONS,
      isDeleting: false,
    }
  },
  setup() {
    const toast = useToast()
    const filterType = ref(COMMUNICATION_TYPES.ANNOUNCEMENT)
    const dataList = ref([])
    const modalFormShow = ref(false)
    const canLoadMore = ref(true)
    const actionChangePage = ref('')
    const communicationItemEdit = ref({})
    const currentPage = ref(1)
    const isCurrentFilterSms = computed(() => filterType.value === COMMUNICATION_TYPES.SMS)
    const LIMIT_PER_PAGE = 9
    const PREV = 'prev'
    const NEXT = 'next'
    const city = ref(null)
    const state = ref(null)

    function fetchData(extraCondition) {
      const dbName = 'messages'
      const conditions = [{ key: 'category', operation: '==', value: filterType.value }]
      const sortOptions = {
        orderBy: { key: 'published', value: 'desc' },
      }
      let pagination = {
        limit: currentPage.value === 1 ? LIMIT_PER_PAGE - 1 : LIMIT_PER_PAGE,
      }

      if (extraCondition) {
        conditions.push({key: extraCondition.key, operation: extraCondition.operator, value: extraCondition.value})
      }

      if (actionChangePage.value) {
        pagination = {
          action: actionChangePage.value,
          limit: LIMIT_PER_PAGE,
          timeStamp: dataList.value.at(actionChangePage.value === PREV ? 0 : -1).published.toDate().getTime(), // Take last item or first item published time according to actionChangePage as timeStamp used for pagination 
        }
      }

      dataList.value = []
      fetchItems(dbName, conditions, sortOptions, pagination).then(res => {
        dataList.value = res
        canLoadMore.value = res.length === (currentPage.value === 1 ? LIMIT_PER_PAGE - 1 : LIMIT_PER_PAGE)
      })
    }

    function refetchData(filter, operator, value) {
      // eslint-disable-next-line no-unused-expressions
      value === null
        ? fetchData()
        : fetchData({key: `target.${filter}`, operator, value})
    }

    function changePage(action) {
      if (action === PREV && currentPage.value > 1) {
        currentPage.value -= 1
        actionChangePage.value = PREV
      }
      if (action === NEXT && canLoadMore.value) {
        currentPage.value += 1
        actionChangePage.value = NEXT
      }
    }

    function handleShowForm(item) {
      if(filterType.value === COMMUNICATION_TYPES.SMS) {
        modalFormShow.value = true
        communicationItemEdit.value = item || {}
      } else {
        router.push({
          name: 'apps-messages-edit',
          params: {
            id: item?.id || null,
            type: filterType.value,
          },
        })
      }
    }

    async function deleteAnnouncement(id) {
      try {
        this.isDeleting = true
        await this.$store.dispatch('appEmail/deleteAnnouncements', { ids: [id] })
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('success'),
            text: 'Ilmoitus poistettu',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.isDeleting = false
        this.refetchData()
      } catch {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('error'),
            text: this.$t('something_went_wrong'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        this.isDeleting = false
      }
    }

    async function handleCreateUpdateSms({ form, id, users, type }) {
      try {
        if (form.status === 'sending') {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Lähetetään SMS-massatekstiviestiä',
              icon: 'SendIcon',
              variant: 'info',
            },
          })
        }
        if (type === 'csv') {
          await this.$store.dispatch('appEmail/sendSmsFromCsv', { id: this.id, users, data: form })
        } else {
          await createUpdateSms({
            smsId: id,
            dataToUpdate: form,
            users,
          })
        }
        toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('success'),
            text: 'Massatekstiviesti lähetetty',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } catch (error) {
        toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('error'),
            text: this.$t('something_went_wrong'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        city.value = null
        state.value = null
        fetchData()
      }
    }

    watch (state, () => {
      if (state.value !== null) {
        city.value = null
      }
      refetchData('state', '==', state.value)
    })

    watch(city, () => {
      if (city.value !== null) {
        state.value = null
      }
      refetchData('city', 'array-contains', city.value)
    })

    // If filterType change then set page to 1, remove actionChangePage and fetchData. If currentPage change then fetchData only
    watch([filterType, currentPage], (newVal, oldVal) => {
      if (newVal[0] !== oldVal[0]) {
        currentPage.value = 1
        actionChangePage.value = ''
      }
      if ((newVal[0] !== oldVal[0]) || (newVal[1] !== oldVal[1])) {
        if (city.value !== null) {
          refetchData('city', 'array-contains', city.value)
        } else if (state.value !== null) {
          refetchData('state', '==', state.value)
        } else {
          fetchData()
        }
      }
    })

    fetchData()

    return {
      COMMUNICATION_TYPES,
      PREV,
      NEXT,
      filterType,
      dataList,
      isCurrentFilterSms,
      modalFormShow,
      canLoadMore,
      communicationItemEdit,
      currentPage,
      city,
      state,
      changePage,
      handleShowForm,
      deleteAnnouncement,
      handleCreateUpdateSms,
      refetchData,
    }
  },
}
</script>
